<script>
    
export default {
    data(){
        return {
            formActive: true,
        };
    },
    computed: {
        currentLocale(){
            return this.$store.state.currentLocaleValue;
        },
    },
    watch : {
        currentLocale(){
            this.updateLocale();
        },
    },
    methods: {
        updateLocale() {
            this.formActive = false;
            this.$nextTick(() => {
                this.formActive = true;
            });
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Mixins/rulesMixins.vue